import {Grid} from '@logistics-frontend/blocks'
import {DrawerSection} from '@logistics-frontend/blocks/legacy'
import clsx from 'clsx'
import React from 'react'

import {
  ContentBarcodeItem,
  ContentDetailsItem,
  ContentHeaderItem,
  ContentItem,
  ContentListItem,
  ContentSection,
  ContentSeparatorItem,
} from 'src/api/types'

import {useIsMobile} from '../../hooks'
import {Details} from '../details'
import {DrawerSection as DrawerSectionDesktop} from '../drawer'
import {Barcode} from './barcode'
import * as classes from './Content.classes'
import {Header} from './Header'
import {ListItem} from './ListItem'
import {Separator} from './Separator'

type Props = {
  sections: ContentSection[]
}

type ComponentsMap<Map extends Record<string, ContentItem> = Record<string, ContentItem>> = {
  [K in keyof Map]: React.FC<{item: Map[K]}>
}

const componentsMap: ComponentsMap<{
  details: ContentDetailsItem
  header: ContentHeaderItem
  list_item: ContentListItem
  separator: ContentSeparatorItem
  barcode: ContentBarcodeItem
}> = {
  details: Details,
  header: Header,
  list_item: ListItem,
  separator: Separator,
  barcode: Barcode,
}

const Content: React.FC<Props> = ({sections}) => {
  const isMobile = useIsMobile(false)
  const DrawerSectionComponent = isMobile ? DrawerSection : DrawerSectionDesktop

  return (
    <>
      {sections.map((section, index) => (
        <DrawerSectionComponent key={index} className={classes.drawerSection}>
          <Grid className={classes.section} container>
            {section.items.map((item, index) => {
              const Component: ComponentsMap[string] | undefined = componentsMap[item.type]

              if (!Component) {
                return null
              }

              return (
                <Grid
                  key={index}
                  className={clsx(item.type !== 'separator' && item.type !== 'header' && classes.sectionItem)}
                  container
                  item
                >
                  <Grid xs={12} item>
                    <Component item={item} />
                  </Grid>
                </Grid>
              )
            })}
          </Grid>
        </DrawerSectionComponent>
      ))}
    </>
  )
}

export default Content
